// extracted by mini-css-extract-plugin
export default {"wrapper":"KmlJk0NxLu","focus":"cqnBeSaDq3","read-only":"ua2I+NVrQ+","readOnly":"ua2I+NVrQ+"};